import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { filter, find, map, pathOr } from 'ramda';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  IconSpinner,
  PrimaryButton,
  Divider,
} from '../../components';
import config from '../../config';
import css from './style.css';
import BookingSearchParams from './BookingSearchParams';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { types as sdkTypes } from '../../util/sdkLoader';
import { isNilOrEmpty } from '../../util/validators';
import CartListingCard from '../../components/CartListingCard/ListingCard';
import { getEstimatedBreakdownMaybe, getPricingDataFromEntity } from '@swimmy_/helpers';
import LisitngPriceDetailsModal from './LisitngPriceDetailsModal/LisitngPriceDetailsModal';
import { IconCheck } from '../../components/Icons';
import routeConfiguration from '../../routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';
import { moment } from '../../util/dates';
import { useHistory, useLocation } from 'react-router-dom';
import SwimPlusConfirmationModal from './SwimPlusConfirmationModal/SwimPlusConfirmationModal';
import DiscountCode from '../../forms/StripePaymentForm/DiscountCode/DiscountCode';
import { verifyDiscountCode } from '../CheckoutPage/CheckoutPage.duck';
import ExtrasContent from './ExtrasContent';
import { removeFromCart } from '../../ducks/user.duck';
// import bg from './img.png';

const { UUID } = sdkTypes;

const CartPageComponent = (props) => {
  const {
    scrollingDisabled,
    intl,
    listingsWithoutTx = [],
    myCart,
    isAuthenticated,
    currentUserLoading,
    currentPageResultIds,
    currentUserSwimPlusLevel,
    fetchCartInProgress,
    fetchCartError,
    fetchCartSuccess,
    cartBookingParams,
    onVerifyDiscountCode,
    discount,
    errorVerifyDiscountCode,
  } = props;
  const history = useHistory();
  const location = useLocation();
  const [listingPriceDetailsModalIsOpen, setListingPriceDetailsModalIsOpen] = useState(false);
  const [isConfirmSwimPlusModalOpen, setIsConfirmSwimPlusModalOpen] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  const [selectedExtrasByListings, setSelectedExtrasByListings] = useState({});
  const [isShowingExtraContent, setIsShowingExtraContent] = useState(false);
  const [listings, setListings] = useState([]);
  const [hasSelectedSwimPlus, setHasSelectedSwimPlus] = useState(false);
  const [isEditingCart, setIsEditingCart] = useState(false);
  const getListings = () =>
    map((l) => {
      const pricingData = getPricingDataFromEntity(l);
      const couponDiscount = discount && {
        valid: true,
        discount: {
          percent_off: discount?.percentage,
        },
      };
      const estimatedTransaction = getEstimatedBreakdownMaybe({
        ...pricingData,
        bookingStart: cartBookingParams.startAt && moment(cartBookingParams.startAt),
        bookingEnd: cartBookingParams.endAt && moment(cartBookingParams.endAt),
        quantity1: cartBookingParams.numberOfPeople.numberOfAdults,
        quantity2: cartBookingParams.numberOfPeople.numberOfChildren,
        quantityHours: cartBookingParams.nbHoursSelected,
        publicData: pathOr({}, ['attributes', 'publicData'], l),
        protectedData: pricingData,
        canApplyCommissionDiscountOnBigBookings: false,
        isTransactionHourlyPlan: true,
        extras: selectedExtrasByListings[l.id.uuid] ?? [],
        swimPlusLevel: currentUserSwimPlusLevel ?? (hasSelectedSwimPlus ? 1 : null),
        couponDiscount,
      });

      return {
        ...l,
        estimatedTransaction,
      };
    }, listingsWithoutTx);
  useEffect(() => {
    const listings = getListings();
    setListings(listings);
    if (selectedListing)
      setSelectedListing(find((l) => l.id.uuid === selectedListing?.id.uuid, listings));
  }, [listingsWithoutTx, selectedExtrasByListings, hasSelectedSwimPlus, currentUserSwimPlusLevel]);

  useEffect(() => {
    if (isAuthenticated && !currentUserLoading && !fetchCartInProgress && isNilOrEmpty(myCart)) {
      history.push(
        createResourceLocatorString('SearchPage', routeConfiguration(), {}, {}, location.search)
      );
    }
  }, [fetchCartInProgress, myCart, isAuthenticated, currentUserLoading, history, location.search]);
  useEffect(() => {
    if (!currentUserSwimPlusLevel || currentUserSwimPlusLevel < 1) return;

    setHasSelectedSwimPlus(false);
  }, [currentUserSwimPlusLevel]);
  const listingsAreLoaded = !fetchCartInProgress && fetchCartSuccess;
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'CartPage.schemaTitle' }, { siteTitle });
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  const queryError = (
    <h2 className={css.error}>
      <FormattedMessage id="ManageListingsPage.queryError" />
    </h2>
  );
  const panelWidth = 62.5;
  // Render hints for responsive image
  const renderSizes = [
    `(max-width: 767px) 100vw`,
    `(max-width: 1920px) ${panelWidth / 2}vw`,
    `${panelWidth / 3}vw`,
  ].join(', ');
  const noResults =
    listingsAreLoaded && isNilOrEmpty(listings) ? (
      <div className={css.rootNoResults}>
        <div className={css.contentNoResults}>
          <h1 className={css.headingNoResults}>
            <FormattedMessage id="CartPage.noResultsHeading" />
          </h1>
          <p className={css.descriptionNoResults}>
            <FormattedMessage id="CartPage.noResultsDescription" />
          </p>
        </div>
      </div>
    ) : null;
  const args = ['CartPage.args.insurance', 'CartPage.args.canceling', 'CartPage.args.multibooking'];
  const handleOpenListingPriceDetailsModal = (listing) => {
    console.log('handleOpenListingPriceDetailsModal', listing);
    setSelectedListing(listing);
    setListingPriceDetailsModalIsOpen(!listingPriceDetailsModalIsOpen);
  };
  const handleOpenConfirmSwimPlusModal = () => {
    setIsConfirmSwimPlusModalOpen(true);
  };
  const handleSubmit = () => {
    if (isNilOrEmpty(listings)) return;

    const hasExtras = isNilOrEmpty(
      filter(
        (listing) =>
          !isNilOrEmpty(pathOr([], ['attributes', 'publicData', 'paidExtrasData'], listing)),
        listings
      )
    );
    if (!hasExtras && !isShowingExtraContent) {
      setIsShowingExtraContent(true);
      return;
    }

    const routes = routeConfiguration();
    history.push(
      createResourceLocatorString(
        'CheckoutPageMultiBooking',
        routes,
        {},
        {
          extras: JSON.stringify(selectedExtrasByListings),
          hasSelectedSwimPlus,
        }
      )
    );
  };
  const hasAcceptedToBeSwimPlus = intl.formatMessage({
    id: 'CartPage.SwimPlus',
  });

  const handleRemoveFromCart = (listingId) => {
    if (!listingId) return;

    const { [listingId]: _, ...restExtras } = selectedExtrasByListings;
    setSelectedExtrasByListings(restExtras);

    if (selectedListing && selectedListing.id && selectedListing.id.uuid === listingId) {
      setListingPriceDetailsModalIsOpen(false);
      setSelectedListing(null);
    }

    props.onRemoveFromCart(listingId);
  };

  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="CartPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav rootClassName={css.leftBlank} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <div className={css.cartContent}>
              <h2 className={css.heading}>
                <FormattedMessage
                  id={isShowingExtraContent ? 'CartPage.extraHeading' : 'CartPage.heading'}
                />
              </h2>
              {isShowingExtraContent ? (
                <ExtrasContent
                  intl={intl}
                  listings={listings}
                  selectedExtrasByListings={selectedExtrasByListings}
                  setSelectedExtrasByListings={setSelectedExtrasByListings}
                  currentUserSwimPlusLevel={currentUserSwimPlusLevel}
                  discount={discount}
                  renderSizes={renderSizes}
                  handleOpenListingPriceDetailsModal={handleOpenListingPriceDetailsModal}
                  hasSelectedSwimPlus={hasSelectedSwimPlus}
                />
              ) : (
                <div>
                  <BookingSearchParams />
                  <div className={css.listingsContent}>
                    {fetchCartInProgress && isNilOrEmpty(listings) && <IconSpinner />}
                    {fetchCartError && queryError}
                    <div className={css.editCartToggleWrapper}>
                      <button
                        type="button"
                        className={css.editCartToggleButton}
                        onClick={() => setIsEditingCart(!isEditingCart)}
                      >
                        <FormattedMessage
                          id={isEditingCart ? 'CartPage.editCartDone' : 'CartPage.editCart'}
                        />
                      </button>
                    </div>
                    {!isNilOrEmpty(listings) && !fetchCartError && (
                      <Fragment>
                        {noResults}
                        <div className={css.listingCards}>
                          {listings.map((l) => (
                            <CartListingCard
                              className={css.listingCard}
                              key={l.id.uuid}
                              listing={l}
                              renderSizes={renderSizes}
                              handleOpenDetails={() => handleOpenListingPriceDetailsModal(l)}
                              selectedExtras={selectedExtrasByListings[l.id.uuid]}
                              swimPlusLevel={
                                isNilOrEmpty(discount) &&
                                (currentUserSwimPlusLevel || (hasSelectedSwimPlus ? 1 : 0))
                              }
                              isPurchasingSwimPlus={
                                !currentUserSwimPlusLevel && hasSelectedSwimPlus
                              }
                              showDelete={isEditingCart}
                              onDelete={() => handleRemoveFromCart(l.id.uuid)}
                            />
                          ))}
                        </div>
                      </Fragment>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className={css.submitCardContainer}>
              <div className={css.submitCard}>
                <div className={css.submitCart}>
                  <PrimaryButton
                    className={css.submitButton}
                    onClick={handleSubmit}
                    disabled={fetchCartInProgress || isNilOrEmpty(listings)}
                  >
                    <FormattedMessage id="CartPage.SubmitMultiBooking" />
                  </PrimaryButton>
                </div>
                <Divider className={css.divider} />
                {(!currentUserSwimPlusLevel || currentUserSwimPlusLevel < 1) && (
                  <div className={css.centered}>
                    <div>
                      <div>
                        <div
                          className={
                            hasSelectedSwimPlus
                              ? css.swimPlusContainer
                              : css.swimPlusContainerUnchecked
                          }
                        >
                          <h3>{intl.formatMessage({ id: 'CartPage.SwimPlusTitle' })}</h3>
                          <label className={css.checkboxContainer}>
                            <input
                              type="checkbox"
                              className={css.checkbox}
                              checked={hasSelectedSwimPlus}
                              onChange={() => setHasSelectedSwimPlus(!hasSelectedSwimPlus)}
                            />
                            {/*<span className={css.checkmark}></span>*/}
                            <span className={css.swimPlusContainerLabel}>
                              {hasAcceptedToBeSwimPlus}
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <Divider className={css.divider} />
                  </div>
                )}
                <div className={css.argsContainer}>
                  {map(
                    (arg) => (
                      <div className={css.arg}>
                        <IconCheck className={css.iconCheck} /> <FormattedMessage id={arg} />
                      </div>
                    ),
                    args
                  )}
                </div>
              </div>
            </div>
          </div>
          <SwimPlusConfirmationModal
            onSubmit={handleSubmit}
            onModalClose={() => setIsConfirmSwimPlusModalOpen(false)}
            onManageDisableScrolling={Function.prototype}
            isModalOpen={isConfirmSwimPlusModalOpen}
          />
          <LisitngPriceDetailsModal
            lisitngPriceDetailsModalOpen={listingPriceDetailsModalIsOpen}
            onLisitngPriceDetailsModalClose={() => handleOpenListingPriceDetailsModal(null)}
            onManageDisableScrolling={Function.prototype}
            listing={selectedListing}
            selectedExtrasByListings={selectedExtrasByListings}
            setSelectedExtrasByListings={setSelectedExtrasByListings}
            isPurchasingSwimPlus={!currentUserSwimPlusLevel && hasSelectedSwimPlus}
          />
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

CartPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
  const { currentUser } = state.user;
  const { currentUserLoading } = state.user;
  const { isAuthenticated } = state.Auth;
  const { currentPageResultIds, fetchCartInProgress, fetchCartError, fetchCartSuccess } =
    state.CartPage;
  const { errorVerifyDiscountCode } = state.CheckoutPage;
  const discount = pathOr({}, ['discount', 'discount'], state.CheckoutPage);
  const cartBookingParams = pathOr(
    {},
    ['attributes', 'profile', 'privateData', 'cartBookingParams'],
    currentUser
  );
  const currentUserSwimPlusLevel = pathOr(
    null,
    ['attributes', 'profile', 'metadata', 'swimPlusLevel'],
    currentUser
  );
  const myCart = pathOr([], ['attributes', 'profile', 'publicData', 'addToCart'], currentUser);
  const listingsWithoutTx = getListingsById(
    state,
    map((fav) => new UUID(fav), myCart)
  );

  return {
    scrollingDisabled: isScrollingDisabled(state),
    listingsWithoutTx,
    myCart,
    isAuthenticated,
    currentUserLoading,
    currentUserSwimPlusLevel,
    currentPageResultIds,
    fetchCartInProgress,
    fetchCartError,
    fetchCartSuccess,
    cartBookingParams,
    discount,
    errorVerifyDiscountCode,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onVerifyDiscountCode: (params) => dispatch(verifyDiscountCode(params)),
  onRemoveFromCart: (listingId) => dispatch(removeFromCart(listingId)),
});

const CartPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(CartPageComponent);

export default CartPage;
